import I18n from 'I18n';
const CHANNEL_I18N_KEY_MAP = {
  FORMS: 'customer-portal-app.ticketThread.channels.forms',
  EMAIL: 'customer-portal-app.ticketThread.channels.email',
  LIVE_CHAT: 'customer-portal-app.ticketThread.channels.liveChat',
  CUSTOMER_PORTAL_THREAD_VIEW: 'customer-portal-app.ticketThread.channels.customerPortal',
  FB_MESSENGER: 'customer-portal-app.ticketThread.channels.facebookMessenger',
  WHATSAPP: 'customer-portal-app.ticketThread.channels.whatsApp',
  SMS: 'customer-portal-app.ticketThread.channels.SMS',
  CALL: 'customer-portal-app.ticketThread.channels.call',
  INSTAGRAM: 'customer-portal-app.ticketThread.channels.instagram',
  MIGRATION: 'customer-portal-app.ticketThread.channels.migration',
  UNKNOWN: 'customer-portal-app.ticketThread.channels.unknown'
};
export const getChannelDisplayName = channel => {
  if (!channel) {
    return I18n.text(CHANNEL_I18N_KEY_MAP.UNKNOWN);
  }
  const i18nKey = CHANNEL_I18N_KEY_MAP[channel];
  return i18nKey ? I18n.text(i18nKey) : channel;
};